const regExpEmail = new RegExp(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+(\.\w{2,6})+$/);

export const validateEmail = (value: string) => regExpEmail.test(value);

export const validatePhone = (value: string) => {
    const fullPhoneLength = 11;
    const localValue = (value || '')?.replaceAll(' ', '');
    return [...localValue].map(Number)
        .filter((elem) => !Number.isNaN(elem)).length === fullPhoneLength;
};